import { useEffect } from "react";
import { MapContainer, TileLayer, CircleMarker, Tooltip, useMap } from "react-leaflet";

function Fit({ points }) {
  const map = useMap();
  const key = points.map((p) => `${p.lat},${p.lng}`).join("|");
  useEffect(() => {
    if (points.length === 1) map.setView([points[0].lat, points[0].lng], 15);
    else if (points.length > 1) map.fitBounds(points.map((p) => [p.lat, p.lng]), { padding: [40, 40] });
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}

// points: [{lat, lng, label, color}]
export default function MapView({ points, className = "h-80", testId = "map-view" }) {
  const valid = points.filter((p) => p.lat != null && p.lng != null);
  return (
    <div className={`${className} rounded-2xl overflow-hidden border`} data-testid={testId}>
      <MapContainer center={[39.92, 32.85]} zoom={6} className="h-full w-full" scrollWheelZoom>
        <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {valid.map((p, i) => (
          <CircleMarker key={i} center={[p.lat, p.lng]} radius={11} pathOptions={{ color: "#fff", weight: 3, fillColor: p.color || "#FF6B0A", fillOpacity: 1 }}>
            <Tooltip permanent direction="top" offset={[0, -10]}>{p.label}</Tooltip>
          </CircleMarker>
        ))}
        <Fit points={valid} />
      </MapContainer>
    </div>
  );
}

export const gmapsLink = (o) =>
  o.lat != null ? `https://www.google.com/maps/dir/?api=1&destination=${o.lat},${o.lng}` : `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(o.address || "")}`;
